const firstNameOf = (name: string) => name.trim().split(/\s+/)[0] || name;

const listOf = (items: string[]) =>
  items.length <= 1
    ? (items[0] ?? "")
    : `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}`;

export const SUPER_ADMIN_LABEL = "Super Admin";
export const SUPER_ADMIN_HINT =
  "Super Admin can do everything, in every entity, so there are no other roles or entities to pick.";

export const ENTITY_ACCESS_TITLE = "Entity Access";
export const ENTITY_ACCESS_HELP = "Choose which Entities the user will have access to.";

export const ALL_CLIENTS_LABEL = "All clients";

/** Verbatim from `new-user-required`: "Team Lead needs clients in GSC. Pick clients, or “All clients”." */
export const requiredBoxMessage = (roleNames: string[], boxLabel: string, entityName: string) => {
  const box = boxLabel.toLowerCase();
  const verb = roleNames.length > 1 ? "need" : "needs";
  const pick = box === "clients" ? `Pick clients, or “${ALL_CLIENTS_LABEL}”.` : `Pick ${box}.`;
  return `${listOf(roleNames)} ${verb} ${box} in ${entityName}. ${pick}`;
};

/** `edge-email-in-use`: the field says the email is taken, never who has it. */
export const EMAIL_IN_USE = "This email is already in use.";

export const TEMPORARY_ROLE = "Temporary Role";
export const END_DATE = "End Date";
export const ADD_TEMPORARY_ROLE = "Add Temporary Role";
export const CHOOSE_A_ROLE = "Choose a role, or remove this.";
export const CHOOSE_AN_END_DATE = "Choose an end date.";
export const ROLE_PICKED_TWICE = "This role is already picked above.";
export const removeTemporaryRoleLabel = (roleName: string | null) =>
  roleName ? `Remove the temporary role ${roleName}` : "Remove this temporary role";

export const ROLES_UNREAD_TITLE = "Couldn't check what these roles need";
export const rolesUnreadMessage = (count: number) =>
  `${count === 1 ? "One role's settings" : `${count} roles' settings`} didn't load, so a value they require may be missing below. Go back and pick the roles again.`;

/** UI26: an entity role picked at the ServEngine level is given as each picked entity's own copy. */
export const ROLE_COPIES_UNREAD =
  "The picked entities' roles didn't load, so their roles can't be given yet. Try again.";
export const noEntityCopyMessage = (missing: { roleName: string; entityName: string }[]) =>
  `${listOf(missing.map(({ roleName, entityName }) => `${entityName} has no ${roleName} role`))}. Pick another role, or leave that entity out.`;
export const roleInEntity = (roleName: string, entityName: string) =>
  `${roleName} in ${entityName}`;

export const CREATE_REFUSED_TITLE = "The user was not created";
export const CREATE_REFUSED_MESSAGE = "Check the details, then try again.";
/** Not "nothing was saved": with no answer, the person may have been created anyway. */
export const CREATE_FAILED_TITLE = "Couldn't confirm the user was created";
export const CREATE_FAILED_MESSAGE =
  "Check the Users list before you try again, so they aren't added twice.";

export const partlySavedTitle = (name: string) =>
  `${firstNameOf(name)} was created, but not everything saved`;

/** Never claims more than was written: the person exists, and these named pieces do not. */
export const partlySavedMessage = (temporaryRoleNames: string[], entityNames: string[]) => {
  const missing = [
    ...temporaryRoleNames.map((role) => `the temporary role ${role}`),
    ...entityNames.map((entity) => `their limits in ${entity}`),
  ];
  return `Not saved: ${listOf(missing)}. Try again, or leave and set them later.`;
};

export const TRY_AGAIN = "Try Again";
export const DONE = "Done";
export const CREATE_USER = "Create User";
export const CREATING = "Creating…";

export const createdToast = (name: string) => `${name} was created`;
